import request from '@/utils/request'

// 取得转帐记录
export function transferRecordList(params) {
  return request({
    url: '/transferRecord/list',
    method: 'get',
    params,
  })
}

// 添加子系统设置
export function smsSysSettingItemAdd(data) {
  return request({
    url: '/smsSysSettingItem/add',
    method: 'post',
    data: data,
  })
}

// 编辑子系统设置
export function smsSysSettingItemUpdate(data) {
  return request({
    url: '/smsSysSettingItem/update',
    method: 'put',
    data: data,
  })
}

// 删除子系统设置
export function smsSysSettingItemDel(data) {
  return request({
    url: '/smsSysSettingItem/del',
    method: 'delete',
    data: data,
  })
}

// 取得子系统设置列表
export function smsSysSettingItemList(params) {
  return request({
    url: '/smsSysSettingItem/list',
    method: 'get',
    params: params,
  })
}

// 添加系统设置
export function systemSettingAdd(data) {
  return request({
    url: '/systemSetting/add',
    method: 'post',
    data: data,
  })
}

// 编辑系统设置
export function systemSettingUpdate(data) {
  return request({
    url: '/systemSetting/update',
    method: 'put',
    data: data,
  })
}

// 删除系统设置
export function systemSettingDel(data) {
  return request({
    url: '/systemSetting/del',
    method: 'delete',
    data: data,
  })
}

// 取得系统设置列表
export function systemSettingList(params) {
  return request({
    url: '/systemSetting/list',
    method: 'get',
    params: params,
  })
}

// 取得地区讯息
export function getRegionsInfo() {
  return request({
    url: '/sys/getRegionsInfo',
    method: 'get',
  })
}

// 取得下线帐号原因列表
export function getLogOutReason() {
  return request({
    url: '/sys/getLogOutReason',
    method: 'get',
  })
}

// 通过类型查找系统设定(字典)
export function getSmsSysSettingItemType(data) {
  return request({
    url: `/smsSysSettingItem/type/${data}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/setting.js